<mat-toolbar class="mat-elevation-z8">
  Open {{ data.camera.name }}
</mat-toolbar>

@if (isLoading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<mat-dialog-content>
  <form [formGroup]="openGateForm">
    <div class="form-container">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'OPEN_GATE.REGISTRATION_NUMBER' | transloco }}</mat-label>
        <input matInput formControlName="RegNr" [placeholder]="'OPEN_GATE.REGISTRATION_NUMBER_PLACEHOLDER' | transloco">
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'OPEN_GATE.ORDER_ID' | transloco }}</mat-label>
        <input matInput formControlName="orderId" [placeholder]="'OPEN_GATE.ORDER_ID_PLACEHOLDER' | transloco">
      </mat-form-field>

      <button mat-raised-button color="primary" (click)="searchOrderDetails()" [disabled]="isLoading">
        <mat-icon>search</mat-icon>
        <span>
          {{ isLoading ? ('OPEN_GATE.PROCESSING' | transloco) : ('OPEN_GATE.SEARCH_ORDER_DETAILS' | transloco) }}
        </span>
      </button>

      <!-- Add this right after the search button -->
      @if (orderDetails) {
        <div class="order-summary">
          <div class="order-header">
            <div class="order-number">Order #{{orderDetails.orderNr}}</div>
            <app-status-badge class="status-badge" [isPayment]="true" [text]="orderDetails.status">
            </app-status-badge>
          </div>
          <div class="customer-info">
            <div class="customer-name"><mat-icon class="icon">person</mat-icon> {{orderDetails.firstName}}
          {{orderDetails.lastName}}</div>
          <div class="customer-contact">
            <mat-icon class="icon">email</mat-icon>
            {{orderDetails.email}}
            <span class="divider">•</span>
            <mat-icon class="icon">phone</mat-icon>
            {{orderDetails.cellular}}
          </div>
        </div>
        <div class="parking-info">
          <div class="info-item">
            <mat-icon class="icon">local_parking</mat-icon>
            <span>{{orderDetails.parking}}</span>
            <span class="divider">•</span>
            <span>{{orderDetails.parkingSiteName}}</span>
          </div>
          <div class="info-item">
            <mat-icon class="icon">schedule</mat-icon>
            <span>
              {{orderDetails.parkingFrom | date:'yyyy-MM-dd HH:mm'}}
              &nbsp; - &nbsp;
              {{orderDetails.parkingTo | date:'yyyy-MM-dd HH:mm'}}
            </span>
          </div>
        </div>
        @if (orderDetails.checkIn || orderDetails.checkOut) {
          <div class="check-in-out">
            @if (orderDetails.checkIn) {
              <div class="check-in">
                <span class="label">Check-in:</span>
                <span class="time">{{orderDetails.checkIn | date:'yyyy-MM-dd HH:mm'}}</span>
              </div>
            }
            @if (orderDetails.checkOut) {
              <div class="check-out">
                <span class="label">Check-out:</span>
                <span class="time">{{orderDetails.checkOut | date:'yyyy-MM-dd HH:mm'}}</span>
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <div class="no-order-details">
        <mat-icon>info</mat-icon>
        <p>No order found. Please search for an order.</p>
      </div>
    }


  </div>
</form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button (click)="onCancel()" [disabled]="isLoading">
    {{ 'OPEN_GATE.CLOSE' | transloco }}
  </button>
  @if (data.camera.gateType === 'Checkin') {
    <button mat-raised-button color="primary"
      (click)="onSubmitCheckInOrOutAndOpenGate()" [disabled]="isLoading" [class.spinner]="isLoading">
      {{ isLoading ? 'Processing...' : (('ORDER_DETAILS.PARKING_SERVICE.CHECK_IN' | transloco) + ' & ' +
      ('OPEN_GATE.TITLE' | transloco)) }}
    </button>
  }
  @if (data.camera.gateType === 'Checkout') {
    <button mat-raised-button color="primary"
      (click)="onSubmitCheckInOrOutAndOpenGate()" [disabled]="isLoading" [class.spinner]="isLoading">
      {{ isLoading ? 'Processing...' : (('ORDER_DETAILS.PARKING_SERVICE.CHECK_OUT' | transloco) + ' & ' +
      ('OPEN_GATE.TITLE' | transloco)) }}
    </button>
  }
  <button mat-raised-button color="primary" (click)="openGate(data.camera.externalId)" [disabled]="isLoading"
    [class.spinner]="isLoading">
    {{ isLoading ? 'Processing...' : 'OPEN_GATE.TITLE' | transloco }}
  </button>
</mat-dialog-actions>
